/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { CornMZSA } from "./modelCornMZSA";

class ControllerCornMZSA extends ControllerModel {
  constructor() {
    super("ControllerCornMZSA");
    
    this.setNewNode = (callback) => {
      let vasteurization = new CornMZSA();
      vasteurization.decorate(callback);

      this.addNode(vasteurization);
    }

    this.loadNode = (node, callback) => {
      let vasteurization = new CornMZSA();
      vasteurization.copyFrom(node);
      vasteurization.decorate(callback);
      this.addNode(vasteurization)
    }

    this.getProperties = async (node) => {
      let n = new CornMZSA();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new CornMZSA();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerCornMZSA };
